import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, OnDestroy, HostBinding, OnChanges, Inject, ElementRef, Renderer2 } from '@angular/core';
import { ProjectWindowComponent } from '../../../project/view/project-window/project-window.component';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import { takeUntilDestroyed } from 'projects/core/src/public-api';
import { filter, debounceTime } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ProjectInfoComponent } from 'projects/mobile/src/app/modules/project/view/project-info/project-info.component';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { timer, Subscription, Subject } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';


@Component({
    selector: 'app-kanban-card',
    templateUrl: './kanban-card.component.html',
    styleUrls: ['./kanban-card.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush
})
@RxJSUnsubscribe
export class KanbanCardComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
    @Input()
    card: Project;

    @Output()
    updateProject = new EventEmitter<number>();

    showCard = true;

    // mouseTimer: Subscription;

    @HostBinding('class.unreaded-project')
    get hasNotification() {
        return this.card && this.card.unreadNotificationCnt > 0
    };

    constructor(
        protected dialog: MatDialog,
        private deviceService: DeviceDetectorService,
        protected projectService: ProjectService,
        protected el: ElementRef,
        protected renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document,
        protected changeDetectorRef: ChangeDetectorRef
    ) {
        this.changeDetectorRef.detach();
    }

    ngOnInit() {
        this.changeDetectorRef.detectChanges();

        this.projectService
            .projectEmitter
            .update
            .pipe(
                takeUntil(this.getUnsubFromAllSubs()),
                filter(event => event.entity.id === this.card.id)
            )
            .subscribe(lastAction => {
                this.changeDetectorRef.detectChanges();
            })

    }

    // @HostListener('mousedown', ['$event'])
    // public onMousedown(event: MouseEvent) {
    // 	this.mouseTimer = timer(500).subscribe(emit => {
    // 		this.execMouseDown();
    // 	})

    // }
    // @HostListener('mouseup', ['$event'])
    // public onMouseup(event: MouseEvent) {
    // 	// if (this.mouseTimer.closed) {
    // 	// 	this.mouseTimer.unsubscribe();
    // 	// }
    // 	// else {
    // 	// 	this.mouseTimer.unsubscribe();
    // 	this.openProjectWindow(this.card.id)
    // 	// }
    // }
    // execMouseDown() {
    // 	// this.rotateHost = true;
    // 	// this.changeDetectorRef.detectChanges();
    // }


    @HostListener('click', ['$event'])
    public onMousedown(event: MouseEvent) {
        // if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
        this.openProjectWindow(this.card.id)
        // }
    }

    getCreatedTime(proposed: Date) {
        return this.countHandM((moment().diff(proposed, 'hours')))
    }


    countHandM(hours: number) {
        const totalDays = Math.trunc(hours / 24)

        const pastHours = Math.trunc(hours - totalDays * 24)

        if (totalDays > 0) {
            return totalDays + 'd ' + pastHours + 'h '
        }
        else {
            return pastHours + 'h '
        }
    }

    openProjectWindow(projectId: number) {
        let dialogRef
        if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
            dialogRef = this.dialog.open(ProjectInfoComponent, {
                data: {
                    projectNumber: projectId
                },
                panelClass: 'project-info-dialog'
            });
        }
        else {
            dialogRef = this.dialog.open(ProjectWindowComponent, {
                data: {
                    projectNumber: projectId,
                },
                panelClass: 'project-window-dialog'
            });
        }

        dialogRef.afterOpened().subscribe(result => {
            this.document.body.classList.add('disable-scroll')
        });


        dialogRef.afterClosed().subscribe(result => {
      this.projectService.getProject(this.card.id).subscribe(project => {
        if (project) {
          this.card = project;
        }
      })

      this.document.body.classList.remove('disable-scroll')
        });
    }

    public tilt(status: boolean): void {
        if (status) {
            this.el.nativeElement.classList.add('rotate-3deg')
        }
        else {
            this.el.nativeElement.classList.remove('rotate-3deg')
        }
    }

    ngOnDestroy(): void {

    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }
}
